// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1mjmq","title":"AfterBackImages_title__20d2w","images":"AfterBackImages_images__3ne1T"};